import * as R from 'ramda';
import * as RA from 'ramda-adjunct';

export const keepOnlyKeysWithValues = R.pickBy(RA.isNotUndefined);
